export default {
	methods:{
		handlePreload( next , func ){
			return func.then(function(data){
					next( vm => vm.setPreloadData(data) );
				})
				.catch((e)=>{
					e = api.parseError(e);
					console.error(e);
					next( vm => vm.setPreloadError(e.message || 'An error occurred') );
				})
				;
		},
		preloadSuccess(data){
			this.setPreloadData(data);
		},
		preloadError(api_error){
			e = api.parseError(api_error);
			console.error(e);
			this.setPreloadError(e.message || 'An error occurred');
		},
		setPreloadError(message){
			this.preload_error = message;
		},
		setPreloadData(data){
			for(var k in data){
				this[k]=data[k];
			}
		},
		setPreloadError(message){
			this.preload_error = message;
		},
	},
};